module.exports = __webpack_public_path__ + "img/ic_wuxingxi.dc28249a.png";